import { Stack, Typography, IconButton, CircularProgress, Tooltip } from '@mui/material'
import CloseRoundedIcon from '@mui/icons-material/CloseRounded'
import { useRef } from 'react'

import { ReactComponent as LinkIcon } from '@/assets/icons/link-blue.svg'
import { ReactComponent as PDFIcon } from '@/assets/icons/pdf-icon.svg'

export function UploadPDF({ handlePdfChange, file, progress = 0, onRemovePdf, uploadingPdf }) {
  const fileSize = getReadableFileSize(file)
  const fileInputRef = useRef(null)

  const handleClickIconButton = e => {
    e.stopPropagation()
    if (fileInputRef.current) {
      fileInputRef?.current?.click()
    }
  }

  return (
    <Stack alignItems={!file ? 'flex-end' : 'flex-start'} justifyContent="flex-end">
      {!file ? (
        <Tooltip arrow title="Upload rubric PDF">
          <IconButton onClick={handleClickIconButton}>
            <LinkIcon />
            <input
              ref={fileInputRef}
              accept="application/pdf"
              style={{
                height: 36,
                position: 'absolute',
                zIndex: -1,
                width: 36,
                opacity: 0,
                cursor: 'pointer',
              }}
              type="file"
              onChange={handlePdfChange}
            />
          </IconButton>
        </Tooltip>
      ) : (
        <Stack
          direction="row"
          gap="12px"
          sx={{
            borderRadius: '16px',
            border: '1px solid #EAECF0',
            background: '#F9FAFB',
            width: 300,
            height: 60,
            padding: '8px',
            position: 'relative',
          }}
        >
          <Stack flexShrink={0}>
            <PDFIcon />
          </Stack>
          <Stack gap="4px">
            <Tooltip title={file?.name}>
              <Typography noWrap sx={{ color: '#344054', fontWeight: 500, lineHeight: '20px', maxWidth: 200 }}>
                {file?.name}
              </Typography>
            </Tooltip>
            <Typography noWrap sx={{ color: '#475467', lineHeight: '20px', maxWidth: 300 }}>
              {fileSize} – {`${progress}% Uploaded`}
            </Typography>
            {uploadingPdf ? (
              <CircularProgress size={20} sx={{ position: 'absolute', right: 5, top: 5 }} />
            ) : (
              <IconButton size="small" sx={{ position: 'absolute', right: 0, top: 0 }} onClick={onRemovePdf}>
                <CloseRoundedIcon fontSize="small" />
              </IconButton>
            )}
          </Stack>
        </Stack>
      )}
    </Stack>
  )
}

function getReadableFileSize(file) {
  if (!file) return ''
  const sizeInKB = file.size / 1024

  if (sizeInKB < 1024) {
    return `${sizeInKB.toFixed(2)} KB`
  }

  return `${(sizeInKB / 1024).toFixed(2)} MB`
}
